<template>
  <div id="contenedor-fuentes-financieras-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevaFuenteFinanciera="registrarNuevaFuenteFinanciera"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoFuentesFinancieras="getFuentesFinancieras"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaFuenteFinanciera"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <registrar-nueva-fuente-financiera
        v-if="mostrarVentanaRegistrarNuevaFuenteFinanciera"
        v-on:cerrar="cerrarRegistrarNuevaFuenteFinanciera">
      </registrar-nueva-fuente-financiera>
    </v-dialog>
    <!-- DIALOGO EDITAR -->
    <v-dialog
    v-if="estaFuenteFinanciera"
      v-model="mostrarVentanaEditarFuenteFinanciera"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <editar-fuente-financiera
      :fuenteFinancieraEditar="estaFuenteFinanciera"
        v-on:cerrar="cerrarEditarFuenteFinanciera">
      </editar-fuente-financiera>
    </v-dialog>
    <!-- DIALOGO ELIMINAR -->
    <v-dialog
    v-if="estaFuenteFinanciera"
      v-model="mostrarVentanaEliminarFuenteFinanciera"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-fuente-financiera
      :fuenteFinancieraEliminar="estaFuenteFinanciera"
        v-on:cerrar="cerrarEliminarFuenteFinanciera">
      </eliminar-fuente-financiera>
    </v-dialog>
  </div>
</template>

<script>
import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevaFuenteFinanciera from '@/components/administracion/configuracion/catalogos/fuentesfinancieras/Nuevo.vue';
import EditarFuenteFinanciera from '@/components/administracion/configuracion/catalogos/fuentesfinancieras/Editar.vue';
import EliminarFuenteFinanciera from '@/components/administracion/configuracion/catalogos/fuentesfinancieras/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'FuentesFinancierasDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaFuenteFinanciera,
    EditarFuenteFinanciera,
    EliminarFuenteFinanciera,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaFuenteFinanciera: false,
      mostrarVentanaEditarFuenteFinanciera: false,
      mostrarVentanaEliminarFuenteFinanciera: false,
      estaFuenteFinanciera: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    fuentesFinancieras: {
      query: FUENTES_FINANCIERAS,
    },
  },
  mounted() {
    eventBus.$on('editar-fuente-financiera', (fuenteFinanciera) => {
      this.estaFuenteFinanciera = fuenteFinanciera;
      this.mostrarVentanaEditarFuenteFinanciera = true;
    });
    eventBus.$on('eliminar-fuente-financiera', (fuenteFinanciera) => {
      this.estaFuenteFinanciera = fuenteFinanciera;
      this.mostrarVentanaEliminarFuenteFinanciera = true;
    });
  },
  methods: {
    registrarNuevaFuenteFinanciera() {
      this.mostrarVentanaRegistrarNuevaFuenteFinanciera = true;
    },
    cerrarRegistrarNuevaFuenteFinanciera() {
      this.mostrarVentanaRegistrarNuevaFuenteFinanciera = false;
    },
    cerrarEditarFuenteFinanciera() {
      this.mostrarVentanaEditarFuenteFinanciera = false;
      this.estaFuenteFinanciera = null;
    },
    cerrarEliminarFuenteFinanciera() {
      this.mostrarVentanaEliminarFuenteFinanciera = false;
      this.estaFuenteFinanciera = null;
    },
  },
  computed: {
    getFuentesFinancieras() {
      if (!this.fuentesFinancieras) return [];
      return this.fuentesFinancieras
      // Filtrar por Texto de Busqueda
        .filter((fuenteFinanciera) => {
          if (!this.filtros.buscarTexto) return fuenteFinanciera;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(fuenteFinanciera.nombre);
          const origen = this.$normalizacionTexto(fuenteFinanciera.origen);

          return (
            expt.test(nombre)
            || expt.test(origen)
            || expt.test(fuenteFinanciera.nombre)
            || expt.test(fuenteFinanciera.origen)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
